import {
  ICheckStyles,
  IComboBoxStyles,
  IContextualMenuStyles,
  IDropdownStyles,
  IPivotStyles,
  ITextFieldStyles,
  IToggleStyles,
} from "@fluentui/react";
import { makeStyles, shorthands } from "@fluentui/react-components";

export const comboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: "250px",
  },
  container: { marginBottom: "32px" },
};
export const heavyComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: "250px",
    marginBottom: "32px",
  },
  label: {
    fontSize: "16px",
    fontWeight: "bold",
  },
};

export const checkboxStyles: Partial<ICheckStyles> = {
  root: {
    margin: "25px 0px",
  },
};

export const pivotOutsideContentStyles: Partial<IPivotStyles> = {
  root: {
    backgroundColor: "var(--figma-color-snowWhite)",
    marginBottom: "10px",
  },
  linkContent: {
    height: "33px",
  },
  link: [
    {
      fontSize: "14px",
      fontWeight: "300",
      paddingBottom: "13px",
      ":hover": {
        backgroundColor: "var(--figma-color-line-blueGray)",
      },
    },
  ],
  linkIsSelected: [
    {
      fontSize: "14px",
      fontWeight: "600",
      color: "var(--figma-color-theme-primary)",
      ":hover": {
        color: "var(--figma-color-theme-primary)",
        backgroundColor: "var(--figma-color-line-blueGray)",
      },
    },
  ],
};

export const pivotInsideContentStyles: Partial<IPivotStyles> = {
  root: {
    backgroundColor: "var(--figma-color-offWhite)",
    marginBottom: "10px",
    borderBottom: "1px solid #ccc",
  },
  linkContent: {
    height: "33px",
  },
  link: [
    {
      fontSize: "14px",
      fontWeight: "300",
      padding: "0 24px",
      paddingBottom: "13px",
      ":hover": {
        backgroundColor: "var(--figma-color-line-blueGray)",
      },
    },
  ],
  linkIsSelected: [
    {
      fontSize: "14px",
      fontWeight: "600",
      color: "var(--figma-color-theme-primary)",
      ":hover": {
        color: "var(--figma-color-theme-primary)",
        backgroundColor: "var(--figma-color-line-blueGray)",
      },
    },
  ],
};

export const getVerticalTextFieldStylesByWidth = (
  width: number
): Partial<ITextFieldStyles> => ({
  subComponentStyles: {
    label: {
      root: {
        flex: 1,
        fontWeight: "normal",
        paddingTop: "0px",
        paddingBottom: "9px",
        width: `${width}px`,
      },
    },
  },
  wrapper: {
    margin: "0 0 15px 0",
    padding: "0",
  },
  fieldGroup: {
    width: `${width}px`,
  },
});
export const verticalTextFieldStyles: Partial<ITextFieldStyles> =
  getVerticalTextFieldStylesByWidth(250);

export const horizontalTextFieldStyles: Partial<ITextFieldStyles> = {
  subComponentStyles: {
    label: {
      root: {
        flex: 1,
        fontWeight: "normal",
        padding: "10px 0",
        width: "150px",
      },
    },
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    margin: "0 0 15px 0",
    padding: "0",
  },
  fieldGroup: {
    width: "130px",
  },
};

export const toggleStyles: Partial<IToggleStyles> = {
  root: {
    display: "flex",
    alignItems: "center",
    margin: "0px",
    padding: "0px",
  },
  label: {
    flex: 1,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontSize: "14px",
    lineHeight: "32px",
    fontWeight: "normal",
    color: "inherit",
    paddingRight: "5px",
  },
};

export const getVerticalDropdwnStylesByWidth = (
  width: number
): Partial<IDropdownStyles> => ({
  root: {
    marginBottom: "15px",
    padding: "0",
  },
  label: {
    flex: 1,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontSize: "14px",
    fontWeight: "inherit",
    color: "#4F4F4F",
  },
  dropdown: {
    width: `${width}px`,
  },
});
export const verticalDropdownStyles = getVerticalDropdwnStylesByWidth(250);

export const horizontalDropdownStyles: Partial<IDropdownStyles> = {
  root: {
    display: "flex",
    alignItems: "center",
    margin: "10px 0",
    padding: "0",
  },
  label: {
    flex: 1,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontSize: "14px",
    lineHeight: "32px",
    fontWeight: "inherit",
    color: "#4F4F4F",
  },
  dropdown: {
    width: "130px",
  },
};

export const DIALOG_CONFIRM_MAX_WIDTH = "min(480px, 90vw)";

export const useDialogStyles = makeStyles({
  dialog: {
    width: "max-content",
    maxWidth: "90%",
    maxHeight: "100%",
  },
});

export const useWarningButtonStyles = makeStyles({
  warning: {
    backgroundColor: "#d83b01",
    color: "#fff",
    ...shorthands.border("none"),
    ":hover:not(:disabled)": {
      backgroundColor: "#c33400",
      color: "#fff",
    },
    ":disabled": {
      backgroundColor: "#F0F0F0",
      color: "#BDBDBD",
      cursor: "not-allowed",
    },
  },
});

export const useWarningButtonWithoutBorderStyles = makeStyles({
  warning: {
    border: "none",
    backgroundColor: "transparent",
    color: "#E60000",
    paddingLeft: "0px",
    paddingRight: "0px",
    ":hover:not(:disabled)": {
      color: "var(--figma-color-status-error)",
    },
    ":hover:disabled": {
      color: "#E60000",
      opacity: 0.2,
      backgroundColor: "transparent",
    },
    ":disabled": {
      color: "#E60000",
      opacity: 0.2,
      cursor: "not-allowed",
    },
  },
});

export const truncatedTextStyles = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};
